import React from "react";
import RawDataPreview from "../RawDataPreview";
import AbundanceDataPreview from "../AbundanceDataPreview";
import WeeklyReportPreview from "../WeeklyReportPreview";
import SpeciesPieChart from "../SpeciesPieChart";
import AbundanceLineGraph from "../AbundanceLineGraph";
import SpeciesStackedBarChart from "../SpeciesStackedBarChart";


const ReportsLayout = ({
    clickedButton,
    rawData,
    onDownloadData,
    columnVisibilityModel,
    setColumnVisibilityModel,
    loading,
    timeZone,
}) => {
    const renderReport = () => {
        switch (clickedButton) {
            case "Raw-Data":
                return (
                    <div>
                        <RawDataPreview
                            data={rawData}
                            onDownloadData={() => onDownloadData()}
                            columnVisibilityModel={columnVisibilityModel}
                            setColumnVisibilityModel={setColumnVisibilityModel}
                            loading={loading}
                            timeZone={timeZone}
                        />
                    </div>
                );
            case "Species-Summary-Among-Collections":
                return (
                    <div>
                        <AbundanceDataPreview
                            data={rawData}
                            onDownloadData={() => onDownloadData()}
                            loading={loading}
                        />
                    </div>
                );
            case "Weekly-Species-report":
                return (
                    <div>
                        <WeeklyReportPreview
                            data={rawData}
                            onDownloadData={() => onDownloadData()}
                            loading={loading}
                        />
                    </div>
                );
            case "Pie-chart":
                return <SpeciesPieChart loading={loading} data={rawData} />;
            case "LineGraph-Chart":
                return (
                    <div>
                        <AbundanceLineGraph
                            data={rawData}
                            onDownloadData={() => onDownloadData()}
                            loading={loading}
                        />
                    </div>
                );
            case "Bar-chart":
                return (
                    <div>
                        <SpeciesStackedBarChart
                            data={rawData}
                            onDownloadData={() => onDownloadData()}
                            loading={loading}
                        />
                    </div>
                );
            default:
                return <div>No report available yet</div>;
        }
    };

    return <>{renderReport()}</>;
};

export default ReportsLayout;
